import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import UserClasses from '../Admin/users/Users.module.css';
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet';
import { Services } from 'Services';
import { useNavigate } from 'react-router-dom';
import { Success, Error } from 'Util/Toast';
import { Button } from '@mui/material';
import CommonTutorClasses from '../Admin/commoncssfiles/CategoryTutor.module.css';
import ReactLoading from 'react-loading';

const AddRecommendedProducts = () => {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm({
        criteriaMode: 'all',
    });
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const token = { Authorization: `token ${localStorage.getItem('Token')}` };
                const response = await Services.getProducts(token);

                if (response.Status === 1) {
                    setProducts(response.products);
                } else {
                    console.error('Error fetching products:', response.Message);
                }
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        fetchProducts();
    }, []);

    const onSubmit = async (data) => {
        setLoading(true);

        const token = { Authorization: `token ${localStorage.getItem('Token')}` };
        const requestBody = {
            productId: parseInt(data.selectedProductId),
        };

        try {
            const response = await Services.addRecommendedProduct(requestBody, token);
            if (response.Status === 1) {
                Success(response.Message);
                navigate('/recommendedproducts'); // Change to your desired route
            } else {
                Error(response.Message);
            }
        } catch (error) {
            Error('An error occurred while adding the recommended product');
            console.error('API error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout Active={'RecommendedProducts'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Create Recommended Product</title>
            </Helmet>
            <div className={UserClasses['main-first-container']}>
                <div className={UserClasses['main-data-tab']}>
                    <div className={UserClasses['add-users-btn']}>
                        <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                            BACK
                        </Button>
                    </div>
                    <div className={CommonTutorClasses['wrapper']} data-aos="zoom-in-down">
                        <h2 className={CommonTutorClasses['main-header']}>Create Recommended Product</h2>
                        <form className={CommonTutorClasses["form"]} onSubmit={handleSubmit(onSubmit)}>
                            <div className={CommonTutorClasses['form-control']}>
                                <label htmlFor="selectedProductId">Select Product</label>
                                <select {...register('selectedProductId', { required: true })}>
                                    <option value="">-- Select Product --</option>
                                    {products.map((product) => (
                                        <option key={product.productId} value={product.productId}>
                                            {product.productName}
                                        </option>
                                    ))}
                                </select>
                                {errors.selectedProductId && <span>This field is required</span>}
                            </div>
                            <button type="submit" disabled={loading}>
                                {loading ? (
                                    <ReactLoading color="green" type="spokes" height={30} width={30} />
                                ) : (
                                    'Submit'
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AddRecommendedProducts;
